import { styled } from 'styled-components';

export const Title = styled.h6`
  background-color: var(--color-primary-light);
  border-radius: var(--border-radius-tiny);
  color: var(--color-text-alt);
  font-size: var(--font-baseline);
  padding: var(--spacing-tiny) var(--spacing-small);
`;
